import API from "./restApi";
import { AxiosResponse } from "axios";

let config = require("../configuration/config");

export function apiGetImportantDates(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/importantdates`);
}

export function apiAddOrUpdateImportantDate(formData): Promise<AxiosResponse> {
  return API.post(
    `${config.serverUrl}/api/addorupdateImportantDate`,
    JSON.stringify(formData),
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json,charset=UTF-8",
      },
    }
  );
}

export function apiDeleteImportantDate(id): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/importantdates/${id}`);
}
